<template>
  <div class="detail">
    <p class="detail--adress">
      <router-link
        style="text-decoration: none; color: var(--font-color)"
        to="/"
      >
        فروشگاه اینترنتی شمع خورشید
      </router-link>

      <router-link
        style="text-decoration: none; color: var(--font-color); direction: rtl"
        :to="{ name: 'detail', params: { id: this.$route.params.id } }"
      >
        / محصول {{ items_detail.f_name }}
      </router-link>
    </p>
    <div class="detail__container">
      <div class="fave">
        <a href="" class="hoooom"
          ><font-awesome-icon
            :class="[favo == 0 ? '' : 'favo']"
            @click.prevent="faveSta"
            icon="heart"
        /></a>
        <!-- <router-link
          :to="{
            name: 'voice-page',
            params: { id: items_detail.sslug }
          }"
          class="hoooom"
          ><font-awesome-icon class="infoc" icon="info-circle"
        /></router-link> -->
      </div>
      <div class="detail__container--product">
        <div class="row">
          <div class="container OoO img" data-scale="3">
            <img
              id="myimage"
              class="img_producto"
              :src="items_detail.f_image"
              alt="Lights"
            />
          </div>
        </div>
        <div class="con__column">
          <div
            class="column"
            :key="(item, index)"
            v-for="(item, index) in items_detail.img"
          >
            <img
              :src="item.image"
              alt="Nature"
              style="width: 100%"
              @click="myFunction"
            />
          </div>
        </div>
      </div>
      <div class="detail__container--info">
        <h4 class="detail__container--info-name">
          {{ items_detail.f_name }}
        </h4>
        <hr class="rrrr" />
        <div class="detail__container--info-brand">
          <p
            v-if="items_detail.brand != null"
            class="detail__container--info-brand-p"
          >
            برند:
            <router-link
              style="text-decoration: none"
              :to="{
                name: 'brand',
                params: { id: items_detail.brand.slug },
              }"
              class="detail__container--info-brand-p-s"
              >{{ items_detail.brand.fa_name }}</router-link
            >
          </p>
          <p
            v-if="items_detail.cat != null"
            class="detail__container--info-brand-c"
            style="margin-bottom: 3em"
          >
            دسته بندی:
            <router-link
              style="text-decoration: none"
              :to="{
                name: 'list',
                params: { id: items_detail.cat.slug },
              }"
              class="detail__container--info-brand-c-s"
              >{{ items_detail.cat.name }}</router-link
            >
          </p>
        </div>
        <ul
          v-if="
            items_detail.colors.length != 0 && items_detail.escflag == 'color'
          "
          class="detail__container--info-detail-color"
          style="margin-top: -3em"
        >
          انتخاب رنگ:
          <div class="dropdown">
            <input
              type="checkbox"
              class="dropdown__switch"
              id="filter-switch"
              hidden
            />
            <label for="filter-switch" class="dropdown__options-filter">
              <ul class="dropdown__filter" role="listbox" tabindex="-1">
                <li class="dropdown__filter-selected" aria-selected="true">
                  رنگ مورد نظر
                  <input type="hidden" :value="null" />
                </li>
                <li>
                  <ul class="dropdown__select">
                    <li
                      class="dropdown__select-option"
                      @click="role"
                      role="option"
                      :key="(item, index)"
                      v-for="(item, index) in items_detail.colors"
                    >
                      <div
                        style="margin-left: 1em"
                        class="pro_color"
                        :style="{ background: item.color }"
                      ></div>
                      {{ item.name }}
                      <input type="hidden" :value="item.id" />
                    </li>
                  </ul>
                </li>
              </ul>
            </label>
          </div>
        </ul>
        <ul
          v-if="
            items_detail.esanse.length != 0 && items_detail.escflag == 'essence'
          "
          class="detail__container--info-detail-color"
          style="margin-top: -3em"
        >
          انتخاب اسانس:
          <div class="dropdown">
            <input
              type="checkbox"
              class="dropdown__switch"
              id="filter-switch--ess"
              hidden
            />
            <label for="filter-switch--ess" class="dropdown__options-filter">
              <ul class="dropdown__filter" role="listbox" tabindex="-1">
                <li class="dropdown__filter-selectedd" aria-selected="true">
                  اسانس مورد نظر
                  <input type="hidden" :value="null" />
                </li>
                <li>
                  <ul class="dropdown__select">
                    <li
                      class="dropdown__select-option"
                      @click="rolee"
                      role="option"
                      :key="(item, index)"
                      v-for="(item, index) in items_detail.esanse"
                    >
                      {{ item.name }}
                      <input type="hidden" :value="item.id" />
                    </li>
                  </ul>
                </li>
              </ul>
            </label>
          </div>
        </ul>
        <!-- <ul
          v-if="items_detail.colors.length != 0"
          class="detail__container--info-detail-color"
          style="margin-top:-3em"
        >
          انتخاب اسانس:
          <div class="dropdown">
            <input
              type="checkbox"
              class="dropdown__switch"
              id="filter-switchh"
              hidden
            />
            <label for="filter-switchh" class="dropdown__options-filter">
              <ul class="dropdown__filter" role="listbox" tabindex="-1">
                <li class="dropdown__filter-selected" aria-selected="true">
                  اسانس مورد نظر
                  <input type="hidden" :value="null" />
                </li>
                <li>
                  <ul class="dropdown__select">
                    <li
                      class="dropdown__select-option"
                      @click="role"
                      role="option"
                      :key="(item, index)"
                      v-for="(item, index) in items_detail.colors"
                    >
                      <div
                        style="margin-left:1em"
                        class="pro_color"
                        :style="{ background: item.color }"
                      ></div>
                      {{ item.name }}
                      <input type="hidden" :value="item.id" />
                    </li>
                  </ul>
                </li>
              </ul>
            </label>
          </div>
        </ul> -->
        <ul
          class="detail__container--info-detail"
          v-if="this.$store.state.dec.length"
        >
          ویژگی های کالا
          <li
            v-if="this.$store.state.dec.sale != null"
            class="detail__container--info-detail-li"
          >
            واحد فروش:
            {{ this.$store.state.dec.sale }}
          </li>
          <li
            v-if="this.$store.state.dec.width != null"
            class="detail__container--info-detail-li"
          >
            عرض:
            {{
              this.$store.state.dec.width.toLocaleString("fa").toPersianDigits()
            }}
          </li>
          <li
            v-if="this.$store.state.dec.height != null"
            class="detail__container--info-detail-li"
          >
            ارتفاع:
            {{
              this.$store.state.dec.height
                .toLocaleString("fa")
                .toPersianDigits()
            }}
          </li>
          <li
            v-if="this.$store.state.dec.length != null"
            class="detail__container--info-detail-li"
          >
            طول :
            {{
              this.$store.state.dec.length
                .toLocaleString("fa")
                .toPersianDigits()
            }}
          </li>
          <div v-if="this.$store.state.dec.mat != 0" class="">
            <li class="detail__container--info-detail-li">
              جنس :
              <span
                :key="(item, index)"
                v-for="(item, index) in this.$store.state.dec.mat"
              >
                {{ item }} ، &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </li>
          </div>
        </ul>
      </div>
      <div class="detail__container--price">
        <p class="detail__container--price-p">
          <font-awesome-icon icon="store" /> فروشگاه : شمع خورشید
        </p>
        <hr class="dddd" />
        <p class="detail__container--price-p">
          <font-awesome-icon icon="shield-alt" /> ضمانت ارسال کالا
        </p>
        <hr class="dddd" />
        <p class="detail__container--price-p">
          <font-awesome-icon icon="save" />وضعیت موجودی:
          <span v-if="items_detail.inventory > 5" class="shr"
            >موجود در انبار</span
          >
          <span
            v-if="items_detail.inventory <= 5 && items_detail.inventory > 0"
            class="shr"
          >
            تنها
            {{ items_detail.inventory.toLocaleString("fa").toPersianDigits() }}
            عدد باقی مانده</span
          >
          <span v-if="items_detail.inventory == 0" class="shr"> ناموجود</span>
        </p>
        <hr class="dddd" />
        <p v-if="items_detail.perc != 0" class="detail__container--price-p">
          <font-awesome-icon icon="save" />سود شما از این خرید:
          <span class="shr"
            >{{
              items_detail.dis_prof_price.toLocaleString("fa").toPersianDigits()
            }}
            تومان</span
          >
        </p>
        <hr class="dddd" />

        <p v-if="items_detail.perc != 0" class="detail__container--price-p">
          <font-awesome-icon icon="save" />قیمت:
          <span class="shr"
            >{{
              items_detail.dis_prof_price1
                .toLocaleString("fa")
                .toPersianDigits()
            }}
            تومان</span
          >
        </p>
        <p v-if="items_detail.perc == 0" class="detail__container--price-p">
          <font-awesome-icon icon="save" />قیمت:
          <span class="shr"
            >{{
              items_detail.price.toLocaleString("fa").toPersianDigits()
            }}
            تومان</span
          >
        </p>
        <div class="con8978">
          <button
            v-if="items_detail.inventory == 0"
            disabled
            class="detail__container--price-butd"
          >
            افزودن به سبد خرید
          </button>
          <button
            v-else
            @click.prevent="addcart"
            class="detail__container--price-but"
          >
            افزودن به سبد خرید
          </button>
        </div>
      </div>
    </div>
    <app-tab></app-tab>
    <app-swipersame></app-swipersame>
  </div>
</template>
<script>
import swiperSame from "./swiperSame.vue";
import tab from "./detailTab.vue";
export default {
  data() {
    return {
      pram: "sss",
      s_color: "",
      favo: 0,
      items_detail: {
        sslug: "",
        escflag: "",
        esanse: {},
        description: "",
        perc: "",
        f_image: "",
        img: {},
        f_name: "",
        e_name: "",
        colors: {},
        price: "",
        brand: {},
        cat: {},
        inventory: "",
        dis_prof_price: "",
        dis_prof_price1: "",
        id: "",
        is_fave: null,
      },
      details: [],
      cat: [],
      det: {
        img: "",
      },
      related: [],
      userData: {
        cat: "",
        name: this.$route.params.id,
        descript: `در این صفحه جزييات محصول ${name} همراه با رنگ ها و قیمت ${name} قرار گرفته شده است`,
      },
    };
  },
  // name: "sunCandle",
  metaInfo() {
    return {
      title: `${this.userData.name} - فروشگاه شمع خورشید`,
      meta: [
        {
          name: "description",
          content: `جزييات محصول ${this.userData.name}  همراه با ویژگی های ظاهری آن که شامل عکس ها ، رنگ محصول ${this.userData.cat} و قیمت است را مشاهده کنید `,
        },
        {
          property: "og:title",
          content: this.userData.name + " - فروشگاه شمع خورشید",
        },
        { property: "og:site_name", content: "فروشگاه شمع خورشید" },
        { property: "og:type", content: "product detail page" },
      ],
    };
  },
  components: {
    appSwipersame: swiperSame,
    appTab: tab,
  },
  watch: {
    $route(to, from) {
      var that = this;
      that.$store.state.load = true;

      // this.userData.name = this.items_detail.f_name;

      String.prototype.toPersianDigits = function () {
        var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        return this.replace(/[0-9]/g, function (w) {
          return id[+w];
        });
      };

      // console.log(localStorage.getItem("profile"));

      if (localStorage.getItem("profile") == null) {
        var id = this.$route.params.id;
        $.ajax({
          url: that.$store.state.url + "api/v1/products/detail/" + id + "/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          type: "GET",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.items_detail.img = data.detail.images;
            that.items_detail.id = data.detail.id;

            that.$store.state.pId = data.detail.id;
            that.items_detail.description = data.detail.description;

            that.items_detail.f_image = data.detail.images[0].image;
            that.items_detail.f_name = data.detail.name;
            that.items_detail.brand = data.detail.brand;
            that.items_detail.cat = data.detail.category;
            that.userData.cat = data.detail.category.name;
            that.items_detail.colors = data.detail.colors;
            that.items_detail.inventory = data.detail.inventory;
            that.userData.name = that.items_detail.f_name;

            that.items_detail.esanse = data.detail.essences;
            that.items_detail.escflag = data.detail.color_or_essence;

            // that.items_detail.is_fave = data.detail.is_fave;
            if (data.detail.is_fav == true) {
              that.favo = 1;
            } else {
              that.favo = 0;
            }

            if (data.detail.dis_prof_price != null) {
              that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
              that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
            }
            // that.cat = data.category;
            that.items_detail.price = data.detail.price;
            that.items_detail.perc = data.detail.discount;
            // that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
            // that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
            // that.det.img = data.detail.images[0].image;
            // that.details = data.detail;
            that.$store.state.info = data.detail.pfeatures;
            that.$store.state.ddd = data.detail.description;

            that.$store.state.dec.length = data.detail.length;
            that.$store.state.dec.height = data.detail.height;
            that.$store.state.dec.width = data.detail.width;
            that.$store.state.dec.mat = data.detail.materials;
            that.$store.state.dec.sale = data.detail.sale_unit;

            that.$store.state.load = false;
            that.$store.state.related = data.related_products;
            $.ajax({
              url:
                that.$store.state.url +
                "api/v1/products/comment/list/" +
                that.$store.state.pId +
                "/",
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              type: "GET",
              // headers: {
              //   Authorization: "Bearer" + " " + localStorage.getItem("profile")
              // },
              success: function (data, textStatus, request) {
                // console.log(data);
                // that.list = data;
                that.$store.state.comments = data;
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {
                that.$store.state.load = false;
              },
            });
            scroll(0, 0);
          },
          error: function (request, textStatus, errorThrown) {
            if (request.state == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
          },
          complete: function () {},
        });
      } else {
        var id = this.$route.params.id;
        $.ajax({
          url: that.$store.state.url + "api/v1/products/detail/" + id + "/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          type: "GET",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.items_detail.img = data.detail.images;
            that.items_detail.id = data.detail.id;

            // console.log(data.detail.id);
            // console.log(data);
            that.$store.state.pId = data.detail.id;
            that.items_detail.description = data.detail.description;

            that.items_detail.description = data.detail.description;
            that.items_detail.f_image = data.detail.images[0].image;
            that.items_detail.f_name = data.detail.name;
            that.items_detail.brand = data.detail.brand;

            that.userData.cat = data.detail.category.name;

            that.items_detail.cat = data.detail.category;
            that.items_detail.colors = data.detail.colors;
            that.items_detail.inventory = data.detail.inventory;
            that.userData.name = that.items_detail.f_name;

            that.items_detail.esanse = data.detail.essences;
            that.items_detail.escflag = data.detail.color_or_essence;

            // that.items_detail.is_fave = data.detail.is_fave;
            if (data.detail.is_fav == true) {
              that.favo = 1;
            } else {
              that.favo = 0;
            }

            if (data.detail.dis_prof_price != null) {
              that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
              that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
            }
            // that.cat = data.category;
            that.items_detail.price = data.detail.price;
            that.items_detail.perc = data.detail.discount;
            // that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
            // that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
            // that.det.img = data.detail.images[0].image;
            // that.details = data.detail;
            that.$store.state.info = data.detail.pfeatures;
            that.$store.state.ddd = data.detail.description;

            that.$store.state.dec.length = data.detail.length;
            that.$store.state.dec.height = data.detail.height;
            that.$store.state.dec.width = data.detail.width;
            that.$store.state.dec.mat = data.detail.materials;
            that.$store.state.dec.sale = data.detail.sale_unit;

            that.$store.state.load = false;
            that.$store.state.related = data.related_products;
            $.ajax({
              url:
                that.$store.state.url +
                "api/v1/products/comment/list/" +
                that.$store.state.pId +
                "/",
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              type: "GET",
              // headers: {
              //   Authorization: "Bearer" + " " + localStorage.getItem("profile")
              // },
              success: function (data, textStatus, request) {
                // console.log(data);
                // that.list = data;
                that.$store.state.comments = data;
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {
                that.$store.state.load = false;
              },
            });
            scroll(0, 0);
          },
          error: function (request, textStatus, errorThrown) {
            if (request.state == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
          },
          complete: function () {},
        });
      }
    },
  },
  created() {
    // console.log(this.$store.state.looo, " booooooooooooooooooooooon");
    var that = this;
    that.$store.state.load = true;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };

    // console.log(localStorage.getItem("profile"));

    if (localStorage.getItem("profile") == null) {
      var id = this.$route.params.id;
      $.ajax({
        url: that.$store.state.url + "api/v1/products/detail/" + id + "/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.items_detail.sslug = data.detail.slug;

          that.items_detail.img = data.detail.images;
          that.items_detail.id = data.detail.id;

          that.$store.state.pId = data.detail.id;

          that.items_detail.f_image = data.detail.images[0].image;
          that.items_detail.f_name = data.detail.name;
          that.items_detail.brand = data.detail.brand;
          that.items_detail.cat = data.detail.category;
          that.items_detail.colors = data.detail.colors;
          that.items_detail.inventory = data.detail.inventory;
          that.items_detail.description = data.detail.description;
          that.userData.name = that.items_detail.f_name;

          that.items_detail.esanse = data.detail.essences;
          that.items_detail.escflag = data.detail.color_or_essence;

          // that.items_detail.is_fave = data.detail.is_fave;
          if (data.detail.is_fav == true) {
            that.favo = 1;
          } else {
            that.favo = 0;
          }

          if (data.detail.dis_prof_price != null) {
            that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
            that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
          }
          // that.cat = data.category;
          that.items_detail.price = data.detail.price;
          that.items_detail.perc = data.detail.discount;
          // that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
          // that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
          // that.det.img = data.detail.images[0].image;
          // that.details = data.detail;

          that.$store.state.info = data.detail.pfeatures;
          that.$store.state.ddd = data.detail.description;

          that.$store.state.dec.length = data.detail.length;
          that.$store.state.dec.height = data.detail.height;
          that.$store.state.dec.width = data.detail.width;
          that.$store.state.dec.mat = data.detail.materials;
          that.$store.state.dec.sale = data.detail.sale_unit;

          that.$store.state.load = false;
          that.$store.state.related = data.related_products;
          $.ajax({
            url:
              that.$store.state.url +
              "api/v1/products/comment/list/" +
              that.$store.state.pId +
              "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            // headers: {
            //   Authorization: "Bearer" + " " + localStorage.getItem("profile")
            // },
            success: function (data, textStatus, request) {
              // console.log(data);
              // that.list = data;
              that.$store.state.comments = data;
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    } else {
      var id = this.$route.params.id;
      $.ajax({
        url: that.$store.state.url + "api/v1/products/detail/" + id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.items_detail.img = data.detail.images;
          that.items_detail.id = data.detail.id;

          that.$store.state.pId = data.detail.id;
          that.items_detail.description = data.detail.description;

          that.items_detail.f_image = data.detail.images[0].image;
          that.items_detail.f_name = data.detail.name;
          that.items_detail.brand = data.detail.brand;
          that.items_detail.cat = data.detail.category;
          that.items_detail.colors = data.detail.colors;
          that.items_detail.inventory = data.detail.inventory;
          that.userData.name = that.items_detail.f_name;

          that.items_detail.esanse = data.detail.essences;
          that.items_detail.escflag = data.detail.color_or_essence;

          // that.items_detail.is_fave = data.detail.is_fave;
          if (data.detail.is_fav == true) {
            that.favo = 1;
          } else {
            that.favo = 0;
          }

          if (data.detail.dis_prof_price != null) {
            that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
            that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
          }
          // that.cat = data.category;
          that.items_detail.price = data.detail.price;
          that.items_detail.perc = data.detail.discount;
          // that.items_detail.dis_prof_price = data.detail.dis_prof_price[1];
          // that.items_detail.dis_prof_price1 = data.detail.dis_prof_price[0];
          // that.det.img = data.detail.images[0].image;
          // that.details = data.detail;
          that.$store.state.info = data.detail.pfeatures;
          that.$store.state.ddd = data.detail.description;

          that.$store.state.dec.length = data.detail.length;
          that.$store.state.dec.height = data.detail.height;
          that.$store.state.dec.width = data.detail.width;
          that.$store.state.dec.mat = data.detail.materials;
          that.$store.state.dec.sale = data.detail.sale_unit;

          that.$store.state.load = false;
          that.$store.state.related = data.related_products;
          $.ajax({
            url:
              that.$store.state.url +
              "api/v1/products/comment/list/" +
              that.$store.state.pId +
              "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            // headers: {
            //   Authorization: "Bearer" + " " + localStorage.getItem("profile")
            // },
            success: function (data, textStatus, request) {
              // console.log(data);
              // that.list = data;
              that.$store.state.comments = data;
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    }
  },
  methods: {
    addcart() {
      this.$store.state.load = true;
      var that = this;
      // console.log($(".dropdown__filter-selected").find("input").val());
      if ($(".dropdown__filter-selected").find("input").val() == "") {
        this.$toastr.e("لطفا رنگ مورد نظر خود را انتخاب کنید.");
        that.$store.state.load = false;
      } else if ($(".dropdown__filter-selectedd").find("input").val() == "") {
        this.$toastr.e("لطفا اسانس مورد نظر خود را انتخاب کنید.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url:
            that.$store.state.url +
            "api/v1/shop/order/create/" +
            this.$store.state.pId +
            "/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          type: "POST",
          data: {
            color: $(".dropdown__filter-selected").find("input").val(),
            essence: $(".dropdown__filter-selectedd").find("input").val(),
          },
          success: function (data, textStatus, request) {
            // console.log(data);
            that.$toastr.s(data);
            $.ajax({
              url: that.$store.state.url + "api/v1/pages/nav/",
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              type: "GET",
              success: function (data, textStatus, request) {
                // console.log(data);
                that.logo = data.logo;
                that.$store.state.load = false;

                if (data.cart_count) {
                  that.$store.state.co = data.cart_count;
                }
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {
                that.$store.state.load = false;
              },
            });
            // setTimeout(function() {
            //   location.reload();
            // }, 1000);
          },
          error: function (request, textStatus, errorThrown) {
            // console.log(request.responseJSON.product[0]);
            // console.log(request.responseJSON);
            if (request.status == 400) {
              for (var i = 0; i < request.responseJSON.length; i++) {
                that.$toastr.e(request.responseJSON[i]);
              }
            } else if (request.status == 401) {
              that.$toastr.e("لطفا ابتدا وارد حساب کاربری خود شوید.");
            } else if (request.state == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
            // that.$toastr.e(request.responseJSON.detail);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    faveSta() {
      var that = this;
      // console.log(this.favo);
      that.$store.state.load = true;
      if (this.favo == 0) {
        $.ajax({
          url:
            that.$store.state.url +
            "api/v1/shop/fav/add/" +
            this.items_detail.id +
            "/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.favo = 1;
            that.$toastr.s(data);
          },
          error: function (request, textStatus, errorThrown) {
            // console.log(request.status);
            if (request.status == 401) {
              that.$toastr.e("لطفا ابتدا وارد حساب کاربری خود شوید.");
            } else if (request.status == 400) {
              // console.log(request.responseJSON.product[0]);
              that.$toastr.e(request.responseJSON.product[0]);
            } else if (request.status == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
            // that.$toastr.e(request.responseJSON.detail);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      } else {
        $.ajax({
          url:
            that.$store.state.url +
            "api/v1/shop/fav/rem/" +
            this.items_detail.id +
            "/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            // console.log(data);
            that.favo = 0;
            that.$toastr.s(data);
          },
          error: function (request, textStatus, errorThrown) {
            if (request.status == 401) {
              that.$toastr.e("لطفا ابتدا وارد حساب کاربری خود شوید.");
            }
            if (request.status == 400) {
              // console.log(textStatus, "4564564");
              // that.$toastr.e(request.res);
            }
            if (request.state == 500) {
              that.$toastr.e("خطایی در سرور به وجود امده");
              that.$store.state.e500 = true;
            } else {
              that.$store.state.e404 = true;
              that.$toastr.e("خطا در برقراری ارتباط");
            }
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    role(e) {
      // console.log(e.target);
      var m = document.querySelector(".dropdown__filter-selected");
      m.innerHTML = e.target.innerHTML;
    },
    rolee(e) {
      // console.log(e.target);
      var m = document.querySelector(".dropdown__filter-selectedd");
      m.innerHTML = e.target.innerHTML;
    },
    zoom(e) {
      // console.log(e);
      // $(e.target)
      //   .children(".img_producto")
      //   .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
      // $(e.target)
      //   .children(".img_producto")
      //   .css({
      //     "transform-origin":
      //       ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
      //       "% " +
      //       ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
      //       "%"
      //   });
    },
    myFunction(e) {
      var expandImg = document.getElementById("myimage");
      expandImg.src = e.target.src;
    },
  },
  mounted() {
    // // Change option selected
    // const label = document.querySelector(".dropdown__filter-selected");
    // const options = Array.from(
    //   document.querySelectorAll(".dropdown__select-option")
    // );

    // options.forEach(option => {
    //   option.addEventListener("click", () => {
    //     label.textContent = option.textContent;
    //     console.log("blue");
    //   });
    // });

    // // Close dropdown onclick outside
    // document.addEventListener("click", e => {
    //   const toggle = document.querySelector(".dropdown__switch");
    //   const element = e.target;
    //   console.log("red");
    //   if (element == toggle) return;

    //   const isDropdownChild = element.closest(".dropdown__filter");

    //   if (!isDropdownChild) {
    //     toggle.checked = false;
    //   }
    // });
    // $(document).ready(function() {
    //   $(".img-zoom").hover(
    //     function() {
    //       $(this).addClass("transition");
    //     },
    //     function() {
    //       $(this).removeClass("transition");
    //     }
    //   );
    // });
    $(".OoO")
      // tile mouse actions
      .on("mouseover", function () {
        // console.log("re");
        $(this)
          .children(".img_producto")
          .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
      })
      .on("mouseout", function () {
        $(this).children(".img_producto").css({ transform: "scale(1)" });
      })
      .on("mousemove", function (e) {
        $(this)
          .children(".img_producto")
          .css({
            "transform-origin":
              ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
              "% " +
              ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
              "%",
          });
      });
  },
};
</script>
<style lang="scss">
.fave {
  display: flex;
  flex-direction: column;
  position: relative;
  right: 0;
  z-index: 5;
  top: 0;
  transform: translate(-100%, -450%);
  @media screen and (max-width: 900px) {
    right: -45%;
    // right: 0%;
    transform: translate(-25%, 50%);
    // flex-direction: row;
  }
  a {
    margin-top: 0.5em;
    text-decoration: none;
    color: var(--font-color);
    @media screen and (max-width: 900px) {
      margin-top: 0.25em;
    }
  }
}
.rrrr {
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dc;
}
.dddd {
  margin: 0 auto;
  width: 85%;
  border: none;
  height: 1px;
  // margin-top: 1em;
  background-color: #cfd8dc;
}
.detail {
  width: 100%;
  height: auto;
  // background: red1;
  margin-top: 7.9em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
  }
  &--adress {
    font-size: 0.8em;
    margin-bottom: -1.2em;
    padding: 1em 1.5em 0 0;
    align-self: flex-end;
    @media screen and (max-width: 900px) {
      font-size: 0.7em;
      margin-bottom: -1.6em;
    }
    @media screen and (max-width: 500px) {
      font-size: 0.6em;
      margin-bottom: -1.6em;
    }
  }
  &__container {
    box-shadow: 0 12px 12px 0 hsla(0, 0%, 71%, 0.11);
    border: 1px solid #e4e4e4;
    width: 98%;
    min-height: 650px;
    margin-top: 2em;
    padding-bottom: 4em;
    // border-radius: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.178);
    background: var(--main-color);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    direction: rtl;
    @media screen and (max-width: 900px) {
      flex-direction: column;
      width: 95%;
      // margin-left: auto;
      // background: red;
    }
    @media screen and (max-width: 500px) {
      flex-direction: column;
      width: 95%;
      // margin-left: auto;
      // background: red;
    }
    &--price {
      margin-left: 1em;
      margin-right: auto;
      background-color: #f5f5f5;
      border: 1px solid #e4e4e4;
      border-radius: 8px;
      width: 380px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: auto;
      background: var(--bg-color);
      // border-right: 1px solid var(--bg-color);
      @media screen and (max-width: 900px) {
        margin-left: 0em;
        margin-right: 0em;
        font-size: 0.8em;
        padding: 1.5em;
        margin-top: 2em;
        // background: red;
        width: 90%;
      }
      @media screen and (max-width: 500px) {
        margin-left: 0em;
        margin-right: 0em;
        font-size: 0.8em;
        padding: 1.5em;
        margin-top: 2em;
        // background: red;
        width: 330px;
      }
      .con8978 {
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        width: 100%;
        @media screen and (max-width: 900px) {
          height: 60px;
          position: fixed;
          bottom: 0%;
          left: 0;
          right: 0;
          z-index: 10 !important;
          background: var(--main-color);
        }
        @media screen and (max-width: 500px) {
          height: 50px;
          position: fixed;
          bottom: 0%;
          left: 0;
          right: 0;
          z-index: 10 !important;
          background: var(--main-color);
        }
      }
      &-butd {
        width: 98%;
        // display: flex;
        background: gray;
        border-radius: 8px;
        text-align: center;
        text-decoration: none;
        padding: 1em;
        margin: 0 auto;
        color: var(--main-color);
        margin-top: 2em;
        // z-index: 7000000;
        cursor: pointer;
        outline: 0;
        font-family: "yekan";
        font-size: 1em;
        border: none;
        font-size: 0.8em;
        margin-bottom: 1em;

        @media screen and (max-width: 900px) {
          height: auto;
          font-size: 1em;
          margin-top: 0;
          display: block;
          margin-bottom: 0;
          // position: fixed;
          // bottom: 0;
          // left: 0;
          // // z-index: 70000000000;
          // background: var(--main-color);
        }
        @media screen and (max-width: 500px) {
          height: auto;
          margin-top: 0;
          display: block;
          margin-bottom: 0;
          // position: fixed;
          // bottom: 0;
          // left: 0;
          // // z-index: 70000000000;
          // background: var(--main-color);
        }
      }
      &-but {
        width: 98%;
        // display: flex;
        background: var(--sub-color);
        border-radius: 8px;
        text-align: center;
        text-decoration: none;
        padding: 1em;
        margin: 0 auto;
        color: var(--main-color);
        margin-top: 2em;
        // z-index: 7000000;
        cursor: pointer;
        outline: 0;
        font-family: "yekan";
        font-size: 1em;
        border: none;
        font-size: 0.8em;
        margin-bottom: 1em;
        // z-index: 0;
        @media screen and (max-width: 900px) {
          height: auto;
          font-size: 1em;
          margin-top: 0;
          display: block;
          margin-bottom: 0;
          // position: fixed;
          // bottom: 0;
          // left: 0;
          // // z-index: 70000000000;
          // background: var(--main-color);
        }
        @media screen and (max-width: 500px) {
          height: auto;
          margin-top: 0;
          display: block;
          margin-bottom: 0;
          // position: fixed;
          // bottom: 0;
          // left: 0;
          // // z-index: 70000000000;
          // background: var(--main-color);
        }
      }
      .shr {
        margin-right: 0.2em;
        color: var(--shrink);
      }
      &-p {
        direction: rtl;
        width: 100%;
        // background: red;
        padding: 1.5em;
        svg {
          margin-left: 0.8em;
          color: var(--shrink);
        }
      }
    }
    &--info {
      margin-right: 1em;
      padding-right: 2em;
      width: 500px;
      height: 400px;
      border-right: 1px solid var(--bg-color);
      @media screen and (max-width: 900px) {
        width: 100%;
        margin-top: 6em;
        border: none;
        margin-right: 0;
        padding-right: 0;
        font-size: 0.9em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
      }
      @media screen and (max-width: 500px) {
        width: 100%;
        margin-top: 6em;
        border: none;
        margin-right: 0;
        padding-right: 0;
        font-size: 0.8em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
      }
      &-name {
        @media screen and (max-width: 900px) {
          margin-right: auto;
          margin-left: auto;
          font-size: 1.6em;
          margin-bottom: 1em;
        }
        @media screen and (max-width: 500px) {
          margin-right: auto;
          margin-left: auto;
          font-size: 1.5em;
          margin-bottom: 1em;
        }
      }
      &-detail {
        // background: red;
        display: flex;
        flex-direction: column;
        margin-top: -0.5em;
        @media screen and (max-width: 900px) {
          margin-right: 2em;
        }
        @media screen and (max-width: 500px) {
          margin-right: 1em;
        }

        &-li {
          color: var(--cat);
          margin: 10px 0 0 0;
          font-size: 0.89em;
          // list-style: red;
          @media screen and (max-width: 900px) {
            // color: red;
            margin-right: 3em;
          }
          @media screen and (max-width: 500px) {
            // color: red;
            margin-right: 2em;
          }
        }
        &-li::before {
          content: "\2022";
          color: var(--cat);

          font-weight: bold;
          display: inline-block;
          width: 1em;
          // margin-left: -1em;
        }
      }
      &-detail-color {
        direction: rtl;
        margin-top: 1em;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        height: 100px;
        // background: red;
        @media screen and (max-width: 900px) {
          margin-right: 2em;
        }
        @media screen and (max-width: 500px) {
          margin-right: 1em;
        }
        &-li {
          direction: rtl;
          align-items: center;
          justify-content: center;
          display: flex;
          color: var(--cat);
          margin: 5px 0;
          font-size: 0.89em;
          margin-right: 1em;
          border: 1px solid var(--cat);
          border-radius: 10px;
          padding: 0.5em 1.5em;
          // list-style: red;
          .color {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            // background: red;
            margin-left: 1em;
            border: 1px solid var(--cat);
          }
        }
        // &-li::before {
        //   content: "\2022";
        //   color: var(--cat);
        //   font-weight: bold;
        //   display: inline-block;
        //   width: 1em;
        //   // margin-left: -1em;
        // }
      }
      &-brand {
        color: var(--cat);
        width: 100%;
        margin-top: 3em;
        display: flex;
        font-size: 0.9em;
        @media screen and (max-width: 900px) {
          margin-right: 2em;
        }
        @media screen and (max-width: 500px) {
          margin-right: 1em;
        }
        &-p {
          margin-left: 1.5em;
          &-s {
            color: var(--shrink);
            border-bottom: 1px dashed var(--shrink);
            margin-right: 0.2em;
          }
        }
        &-c {
          margin-left: 1.5em;
          &-s {
            color: var(--shrink);
            border-bottom: 1px dashed var(--shrink);
            margin-right: 0.2em;
          }
        }
      }
      // background: red;
      // padding: 0.5em;
      // margin-right: 1em;
      // background: red;
    }
    &--product {
      position: relative;
      width: 350px;
      height: 400px;
      padding: 0.5em;
      margin-right: 1em;
      // background: red;
      @media screen and (max-width: 900px) {
        margin-right: 0;
        margin-top: 1.5em;
        // background: red;
        // width: 400px;
        // height: 550px;
      }
      @media screen and (max-width: 500px) {
        margin-right: 0;
        margin-top: 1.5em;
      }
    }
  }
}
.image {
  width: 500px;
}
.con__column {
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: visible;
  align-items: center;
  justify-content: flex-start;
  // background: red;
  scrollbar-width: thin;
  scrollbar-color: var(--font-color) var(--main-color);
}
.column {
  float: right;
  padding: 5px;
  // width: 100%;
  // background: blue;
  height: auto;
  margin-top: 3em;
  display: flex;

  // margin-left: 0;
  img {
    width: 100px !important;
    height: 100px !important;
    padding: 0.2em;
    border: 1px solid rgb(207, 207, 207);
    border-radius: 5px;
  }
}
#expandedImg {
  background: chartreuse;
  width: 150px;
}
.column img {
  opacity: 0.8;
  cursor: pointer;
}
.column img:hover {
  opacity: 1;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}
.container {
  width: 100% !important;
  height: 300px !important;
  position: relative;
  cursor: zoom-in;
  img {
    width: 100% !important;
    height: 100% !important;
  }
}

.img-zoom {
  width: 310px;
  transition: all 0.2s ease-in-out;
  display: block;
}

.transition {
  transform: scale(1.5);
}

.img {
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
}
/* Expanding image text */
#imgtext {
  position: absolute;
  bottom: 15px;
  left: 15px;
  color: white;
  font-size: 20px;
}
.img_producto_container {
  width: 500px;
  height: 300px;
  position: relative;
  overflow: hidden;
  cursor: zoom-in;
}
.img_producto {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: transform 0.5s ease-out;
}
// .............
$tablet: 400px;

@mixin breakpoint($point) {
  @if $point == untilTablet {
    @media (max-width: $tablet - 1) {
      @content;
    }
  } @else if $point == tablet {
    @media (min-width: $tablet) {
      @content;
    }
  }
}
.dropdown__filter-selected,
.dropdown__filter-selectedd {
  display: flex;
  font-family: "yekan";
}
.dropdown {
  width: 100px;
  margin: 0 20px;
  padding: 20px;
  // background-color: red;
  direction: rtl;
  display: flex;
  justify-content: center;
  align-items: center;
  // box-shadow: 0 8px 10px 0 rgba(0, 0, 0, 0.3);
  font-family: "Lato", sans-serif;
  @media screen and (max-width: 900px) {
    margin-right: -1em;
    margin: 0 10px;
    padding: 0px;
    // font-size: 0.5em;
  }
  @media screen and (max-width: 500px) {
    margin-right: -1em;
    margin: 0 10px;
    padding: 0px;
    // font-size: 0.5em;
  }
  @media screen and (max-width: 400px) {
    margin-right: -1em;
    margin: 0 10px;
    padding: 0px;
    // background: red;
    // font-size: 0.5em;
    width: 200px;
  }
  @include breakpoint(tablet) {
    width: 250px;
    height: 50px;
  }

  &__switch:checked + &__options-filter &__select {
    transform: scaleY(1);
  }

  &__switch:checked + &__options-filter &__filter:after {
    transform: rotate(-135deg);
  }

  &__options-filter {
    width: 100%;
    cursor: pointer;
  }

  &__filter {
    position: relative;
    display: flex;
    padding: 10px;
    color: #595959;
    background-color: var(--main-color);
    border: 1px solid #d6d6d6;
    border-radius: 8px;
    font-size: 14px;
    text-transform: uppercase;
    transition: 0.3s;
    @media screen and (max-width: 900px) {
      font-size: 13px;
    }
    @media screen and (max-width: 500px) {
      font-size: 10px;
    }
    &:focus {
      border: 1px solid var(--shrink);
      outline: none;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.144);
    }

    &::after {
      position: absolute;
      top: 45%;
      left: 20px;
      content: "";
      width: 5px;
      height: 5px;
      border-right: 2px solid #595959;
      border-bottom: 2px solid #595959;
      transform: rotate(45deg) translateX(-45%);
      transition: 0.2s ease-in-out;
    }
  }

  &__select {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    margin-top: 5px;
    overflow: hidden;
    border: 1px solid var(--bg-color);
    // box-shadow: 0 5px 10px 0 rgba(152, 152, 152, 0.6);
    transform: scaleY(0);
    transform-origin: top;
    // font-weight: 300;
    transition: 0.2s ease-in-out;
    height: auto;
    max-height: 120px;
    overflow: hidden;
    overflow-y: visible;
    font-family: "yekan";
  }

  &__select-option {
    padding: 10px;
    background-color: #fff;
    border-bottom: 1px solid var(--bg-color);
    transition: 0.3s;
    display: flex;
    &:last-of-type {
      border-bottom: 0;
    }

    &:hover {
      background-color: #f9f9f9;
    }
  }
}
.pro_color {
  width: 15px;
  height: 15px;
  border: 1px solid var(--font-color);
  // background: red;
  border-radius: 50%;
  // justify-self: flex-end;
  // margin-right: auto;
  margin-top: 0.15em;
}
.dropdown__select {
  z-index: 5;
  scrollbar-width: thin;
  scrollbar-color: var(--font-color) var(--bg-color);
}
.dropdown__select-option {
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.favo {
  color: var(--shrink) !important;
}
.infoc {
  color: var(--shrink) !important;
}
.hoooom {
  // background: var(--sub-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  fill: white;
  font-size: 2em;
  // pointer-events: none;
  svg {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.21em;
    border-radius: 50%;
    border: 1px solid var(--sub-color);
    // margin: 1em;
    cursor: pointer;
    color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/detail.vue